export default {"src":"/_next/static/media/check-circle.136df26d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};